import React from "react";
import "./style/SignUpOTPScreen.module.scss";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";

import FInputt from "../../components/FInputt/FInputt";
import { useSignUpOTPScreen } from "./hooks/useSignUpOTPScreen";
import Fbutton from "../../components/Finputs/FButton/Fbutton";

const SignUpOTPScreen = ({ param }) => {
  const {
    parameters,
    formik,
    handleEnter,
    _expirationTime,
    _waitingTime,
    _SingUpSendCode,
    route,
  } = useSignUpOTPScreen();

  return (
    <>
      <div className="sm:border-0 sm:border-red-600 sm:h-screen sm:relative sm:grid sm:place-items-center">
        <div className="w-screen border-0 h-[37rem] sm:w-[670px] md:w-[770px] lg:w-[970px]  sm:shadow-2xl sm:absolute border-red-600 grid grid-rows-6 sm:grid-rows-1 grid-cols-1 sm:grid-cols-12">
          <div
            className="absolute pt-10 sm:pt-6 pl-5 sm:pl-5 z-50 cursor-pointer"
            onClick={() => {
              route("/");
            }}
          >
            <div className="w-11 h-11 bg-white rounded-full grid place-items-center">
              <ArrowLeftIcon className="w-6" />
            </div>
          </div>
          <img
            src={require("../../components/assets/images/3-h.png")}
            className="border-0 hidden sm:block border-red-600 w-full h-full gap-0 row-span-3 sm:grid-rows-1 col-span-7"
          />
          <img
            src={require("../../components/assets/images/3-v.png")}
            className="border-0 sm:hidden block border-red-600 w-full gap-0 row-span-3 sm:grid-rows-1 col-span-7"
          />

          <div className="border-0 absolute sm:pl-[50%] md:pl-[50%]  pt-[45%] sm:pt-0 border-blue-600 w-full sm:h-[100%] row-span-3 sm:grid-rows-1 col-span-5 sm:grid sm:items-center">
            <form
              className="text-center px-5 sm:px-6 md:px-10 lg:px-16"
            >
              <div className="text-center pt-5 sm:pt-0">
                <div className="text-md pb-4 grid justify-center font-bold text-Secondary">
                  <img
                    src={require("../../components/assets/images/send-message.png")}
                    className="w-28 sm:w-28"
                  />
                </div>

                <div className="font-bold mt-1 text-large pb-2">
                  Enviamos un mensaje a tu móvil
                </div>
                <div className="text-[14px] font-regular">
                  Ingresa el código que te mandamos
                </div>
                <div className="text-large pb-4 mt-3 grid justify-center font-bold  text-Secondary">
                  <FiconPhoneNumber
                    sizeIcon="25px"
                    phoneNumber={parameters.state.phoneNumber}
                  />
                </div>
                <div className="text-left text-sm grid justify-center">
                  <div>
                    <div className="w-[65px] float-left">
                      <FInputt
                        type="tel"
                        name="code1"
                        maxLength="1"
                        formik={formik}
                        onKeyDown={handleEnter}
                        placeholder=""
                        className="w-full h-[58px] rounded-xl border-primary border-[2.5px] focus:bg-primary font-extrabold text-center text-[22px]"
                      />
                    </div>
                    <div className="w-16 float-left">
                      <FInputt
                        type="tel"
                        name="code2"
                        maxLength="1"
                        formik={formik}
                        onKeyDown={handleEnter}
                        placeholder=""
                        className="w-full h-[58px] rounded-xl border-primary border-[2.5px] focus:bg-primary font-extrabold text-center text-[22px]"
                      />
                    </div>
                    <div className="w-16 float-left">
                      <FInputt
                        type="tel"
                        name="code3"
                        maxLength="1"
                        formik={formik}
                        onKeyDown={handleEnter}
                        placeholder=""
                        className="w-full h-[58px] rounded-xl border-primary border-[2.5px] focus:bg-primary font-extrabold text-center text-[22px]"
                      />
                    </div>
                    <div className="w-16 float-left">
                      <FInputt
                        type="tel"
                        name="code4"
                        maxLength="1"
                        formik={formik}
                        onKeyDown={handleEnter}
                        placeholder=""
                        className="w-full h-[58px] rounded-xl border-primary border-[2.5px] focus:bg-primary font-extrabold text-center text-[22px]"
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-2 text-sm grid justify-center">
                  <div className="font-regular text-[13.5px]">
                    <div className="float-left">
                      {"Expiración del código en"}&nbsp;
                    </div>
                    <div className="float-left font-bold text-Secondary">
                      {_expirationTime}
                    </div>
                  </div>
                </div>
                <div className="mt-2 text-sm grid justify-center">
                  <div
                    className={`${
                      _waitingTime == "00:00" ? "grid place-items-center" : ""
                    } font-regular text-[13.5px]`}
                  >
                    <div className="float-left ">
                      {_waitingTime == "00:00"
                        ? "¿No has podido validar tu número?"
                        : "Solicita nuevo código en"}
                      &nbsp;
                    </div>
                    <div className="float-left font-bold text-Secondary">
                      {_waitingTime == "00:00" ? (
                        <div
                          className="cursor-pointer hover:underline"
                          onClick={_SingUpSendCode}
                        >
                          Solicita un nuevo código
                        </div>
                      ) : (
                        _waitingTime
                      )}
                    </div>
                  </div>
                </div>
                <div className="m-4 pb-4 sm:pb-0">
                <Fbutton
                  value={"Continuar"}
                  disabled={(!(formik.isValid && formik.dirty) || _expirationTime == "00:00")}
                  onClick={formik.handleSubmit} 
                />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpOTPScreen;
